import { useCallback } from 'react';
import { useSegments, usePathname } from 'expo-router';

// Tab name → pushable route. Shared by the floating tab bar (mobile) and
// the sidebar nav (desktop shell) so the two stay in lockstep.
export const TAB_ROUTE_MAP: Record<string, string> = {
  index: '/(tabs)',
  feed: '/(tabs)/feed',
  funding: '/(tabs)/funding',
  alerts: '/(tabs)/alerts',
};

/**
 * Returns a predicate deciding whether a tab (by ALL_TABS name) matches the
 * current route. Extracted from GlobalFloatingTabBar so SidebarNav renders
 * the identical active state.
 */
export function useActiveTab() {
  const segments = useSegments();
  const pathname = usePathname();

  return useCallback(
    (tabName: string): boolean => {
      const currentTab = (segments as string[])[1] as string | undefined;
      if (tabName === 'index') {
        return (
          pathname === '/' ||
          (segments[0] === '(tabs)' && (currentTab === undefined || currentTab === 'index'))
        );
      }
      return currentTab === tabName;
    },
    [segments, pathname]
  );
}
